import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useRedeemFantasyFamInvite } from "../../../lib/api/fantasy-fams";

// /fantasy-fam/join/:token — landing route for a shared Fantasy Fam invite
// link. AuthGuard wraps this, so an unauthenticated visitor is bounced to
// /auth/login?next=… first and lands back here signed in. We then POST the
// token to the redeem endpoint and navigate to the Fantasy Fam.
export function FantasyFamJoinRoute() {
	const { token } = useParams<{ token: string }>();
	const navigate = useNavigate();
	const redeem = useRedeemFantasyFamInvite();
	const [error, setError] = useState<string | null>(null);
	// Guard against React 18 StrictMode double-invoke + re-renders firing
	// the mutation twice. The redeem is idempotent server-side, but a single
	// clean call keeps the UX tidy.
	const firedRef = useRef(false);

	useEffect(() => {
		if (firedRef.current) return;
		firedRef.current = true;
		if (!token) {
			setError("This invite link is missing its token.");
			return;
		}
		void redeem
			.mutateAsync({ token })
			.then((res) => {
				void navigate(`/fantasy-fam/${res.fantasyFam.slug}`, {
					replace: true,
				});
			})
			.catch((err: unknown) => {
				setError(
					err instanceof Error
						? err.message
						: "Couldn't redeem this invite link.",
				);
			});
	}, [token, redeem, navigate]);

	return (
		<div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center gap-4 px-4 text-center">
			{!error ? (
				<>
					<p className="text-sm text-[var(--color-muted)]">
						Joining the Fantasy Fam…
					</p>
				</>
			) : (
				<>
					<h1 className="text-lg font-semibold">Invite link problem</h1>
					<p className="text-sm text-[var(--color-danger)]">{error}</p>
					<Link
						to="/fantasy"
						className="rounded-md border border-[var(--color-border)] px-3 py-1.5 text-sm hover:border-[var(--color-accent)]"
					>
						← Back to Fantasy
					</Link>
				</>
			)}
		</div>
	);
}
